import DouglasURL, { ReactComponent as Douglas } from "./Douglas.svg"
import DouglasKleinURL, { ReactComponent as DouglasKlein } from "./Douglas-whitespace.svg"
import MuellerURL, { ReactComponent as Mueller } from "./Müller.svg"
import MüllerKleinURL, { ReactComponent as MüllerKlein } from "./Müller-whitespace.svg"
import ApothekeURL, { ReactComponent as Apotheke } from "./Apotheke.svg"
import FlaconiURL, { ReactComponent as Flaconi } from "./Flaconi.svg"
import FlaconiKleinURL, { ReactComponent as FlaconiKlein } from "./Flaconi-whitespace.svg"
import KadeweURL, { ReactComponent as Kadewe } from "./Kadewe.svg"
import KadeweKleinURL, { ReactComponent as KadeweKlein } from "./Kadewe-whitespace.svg"
import EdenURL, { ReactComponent as Eden } from "./eden-project-logo.svg"
import GalileoURL, { ReactComponent as Galileo } from "./Galileo.svg"
import InStyleURL, { ReactComponent as InStyle } from "./InStyle.svg"
import BunteURL, { ReactComponent as Bunte } from "./Bunte.svg"
import WeltURL, { ReactComponent as Welt } from "./Welt.svg"
import GlamourURL, { ReactComponent as Glamour } from "./Glamour.svg"
import ARDURL, { ReactComponent as ARD } from "./ARD.svg"
import VISAURL, { ReactComponent as VISA } from "./VISA.svg"
import CosmopolitanURL, { ReactComponent as Cosmopolitan } from "./Cosmopolitan.svg"
import RTLURL, { ReactComponent as RTL } from "./RTL.svg"
import SZURL, { ReactComponent as SZ } from "./SZ.svg"
import DHLURL, { ReactComponent as DHL } from "./DHL.svg"
import FacebookURL, { ReactComponent as Facebook } from "./Facebook.svg"
import InstagramURL, { ReactComponent as Instagram } from "./Instagram.svg"
import ProSiebenURL, { ReactComponent as ProSieben } from "./pro7.svg"
import DaysBitmapURL, { ReactComponent as DaysBitmap } from "./DaysBitmap.svg"
import TrustedShopsURL, { ReactComponent as TrustedShops } from "./trusted-logo.svg"
import TrustedBitmapURL, { ReactComponent as TrustedBitmap } from "./TrustedBitmap.svg"
import SSLBitmapURL, { ReactComponent as SSLBitmap } from "./SSLBitmap.svg"
import InstagramWhiteURL, { ReactComponent as InstagramWhite } from "./InstagramWhite.svg"
import InstagramBlueURL, { ReactComponent as InstagramBlue } from "./InstagramBlue.svg"
import FacebookWhiteURL, { ReactComponent as FacebookWhite } from "./FacebookWhite.svg"
import VoucherLogoURL, { ReactComponent as VoucherLogo } from "./VoucherLogo.svg"
import FacebookBlueURL, { ReactComponent as FacebookBlue } from "./FacebookBlue.svg"
import AmericanExpressWhiteURL, {
  ReactComponent as AmericanExpressWhite,
} from "./AmericanExpressWhite.svg"
import MasterCardWhiteURL, { ReactComponent as MasterCardWhite } from "./MasterCardWhite.svg"
import PayPalURL, { ReactComponent as PayPal } from "./paypal-logo.svg"
import StarWhiteURL, { ReactComponent as StarWhite } from "./StarWhite.svg"
import SleepInkURL, { ReactComponent as SleepInk } from "./SleepInk.svg"
import verifiziertURL, { ReactComponent as verifiziert } from "./verfiziert.svg"
import ApothekeAdhocURL, { ReactComponent as ApothekeAdhoc } from "./apotheke-adhoc.svg"
import BZURL, { ReactComponent as BZ } from "./bz.svg"
import ElleURL, { ReactComponent as Elle } from "./elle.svg"
import FAZURL, { ReactComponent as FAZ } from "./faz.svg"
import FreundinURL, { ReactComponent as Freundin } from "./freundin.svg"
import GQURL, { ReactComponent as GQ } from "./gq.svg"
import InTouchURL, { ReactComponent as InTouch } from "./intouch.svg"
import PetraURL, { ReactComponent as Petra } from "./petra.svg"
import KlarnaURL, { ReactComponent as Klarna } from "./klarna.svg"
import KlarnaWhiteURL, { ReactComponent as KlarnaWhite } from "./klarna-white.svg"

const componentMap = {
  AmericanExpressWhite,
  Apotheke,
  ApothekeAdhoc,
  ARD,
  Bunte,
  BZ,
  Cosmopolitan,
  DaysBitmap,
  DHL,
  Douglas,
  DouglasKlein,
  Eden,
  Elle,
  Facebook,
  FacebookBlue,
  FacebookWhite,
  FAZ,
  Flaconi,
  FlaconiKlein,
  Freundin,
  Galileo,
  Glamour,
  GQ,
  Instagram,
  InstagramBlue,
  InstagramWhite,
  InStyle,
  InTouch,
  Kadewe,
  KadeweKlein,
  Klarna,
  KlarnaWhite,
  MasterCardWhite,
  Mueller,
  MüllerKlein,
  PayPal,
  Petra,
  ProSieben,
  RTL,
  SleepInk,
  SSLBitmap,
  StarWhite,
  SZ,
  TrustedBitmap,
  TrustedShops,
  verifiziert,
  VISA,
  VoucherLogo,
  Welt,
}

const urlMap = {
  AmericanExpressWhite: AmericanExpressWhiteURL,
  Apotheke: ApothekeURL,
  ApothekeAdhoc: ApothekeAdhocURL,
  ARD: ARDURL,
  Bunte: BunteURL,
  BZ: BZURL,
  Cosmopolitan: CosmopolitanURL,
  DaysBitmap: DaysBitmapURL,
  DHL: DHLURL,
  Douglas: DouglasURL,
  DouglasKlein: DouglasKleinURL,
  Eden: EdenURL,
  Elle: ElleURL,
  Facebook: FacebookURL,
  FacebookBlue: FacebookBlueURL,
  FacebookWhite: FacebookWhiteURL,
  FAZ: FAZURL,
  Flaconi: FlaconiURL,
  FlaconiKlein: FlaconiKleinURL,
  Freundin: FreundinURL,
  Galileo: GalileoURL,
  Glamour: GlamourURL,
  GQ: GQURL,
  Instagram: InstagramURL,
  InstagramBlue: InstagramBlueURL,
  InstagramWhite: InstagramWhiteURL,
  InStyle: InStyleURL,
  InTouch: InTouchURL,
  KaDeWe: KadeweURL,
  KadeweKlein: KadeweKleinURL,
  Klarna: KlarnaURL,
  KlarnaWhite: KlarnaWhiteURL,
  MasterCardWhite: MasterCardWhiteURL,
  Mueller: MuellerURL,
  MüllerKlein: MüllerKleinURL,
  PayPal: PayPalURL,
  Petra: PetraURL,
  ProSieben: ProSiebenURL,
  RTL: RTLURL,
  SleepInk: SleepInkURL,
  SSLBitmap: SSLBitmapURL,
  StarWhite: StarWhiteURL,
  SZ: SZURL,
  TrustedBitmap: TrustedBitmapURL,
  TrustedShops: TrustedShopsURL,
  verifiziert: verifiziertURL,
  VISA: VISAURL,
  VoucherLogo: VoucherLogoURL,
  Welt: WeltURL,
}

export { componentMap, urlMap }
